import { render, staticRenderFns } from "./PortfolioEdit.vue?vue&type=template&id=3103eb30&"
import script from "./PortfolioEdit.vue?vue&type=script&lang=js&"
export * from "./PortfolioEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports